"use client";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

export default function KdbDateTabs({ selectedDate, onDateChange }) {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];
    options.push({ value: "live", label: "Kèo trực tiếp" });
    options.push({ value: todayString, label: "Hôm nay" });

    const tomorrow = today.clone().add(1, "day");
    options.push({ value: tomorrow.format("YYYY-MM-DD"), label: "Ngày mai" });

    for (let i = 2; i <= 6; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: d.format("DD/MM"),
      });
    }

    return options;
  }, [today, todayString]);

  return (
    <div className="rounded-[4px] p-[10px]">
      <div className="flex items-center gap-[6px] overflow-x-auto no-scrollbar">
        {dateOptions.map((opt) => {
          const isActive = selectedDate === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onDateChange?.(opt.value)}
              className={`h-[40px] shrink-0 cursor-pointer rounded-[6px] px-[15px] text-[14px] no-underline transition-all ${isActive
                ? "kdb-tab-active-alt font-medium text-white"
                : "bg-white font-medium kdb-tab-text-inactive shadow-sm hover:kdb-tab-hover"
                } ${opt.label === "Hôm nay" ? "w-[90px] px-0 font-semibold" : ""}`}
              style={{
                border: 0,
                outline: "none",
                boxShadow: isActive ? "none" : undefined,
                appearance: "none",
                WebkitAppearance: "none",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
